import { render, staticRenderFns } from "./DxEmployeeForm.vue?vue&type=template&id=1ed82832&"
import script from "./DxEmployeeForm.vue?vue&type=script&lang=js&"
export * from "./DxEmployeeForm.vue?vue&type=script&lang=js&"
import style0 from "./DxEmployeeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports